import { CustomUseInfiniteQueryOptions } from '../types';
import { getNextPageParam, getPreviousPageParam } from '../utils';
import { hasNonEmptyProp } from '@/libs/common/utils';
import type { ApiInstance, CommentsApiResult, CommentsParams, RequireOnly } from '@/libs/sdk/api';
import { useInfiniteQuery, keepPreviousData } from '@tanstack/react-query';

export const useComments = (
  api: ApiInstance,
  searchParams: RequireOnly<CommentsParams, 'postUuid'>,
  options?: CustomUseInfiniteQueryOptions<CommentsApiResult>
) => {
  const { page = 1, pageSize = 10 } = searchParams || {};
  const { queryKey, enabled = true, ...rest } = options || {};
  return useInfiniteQuery({
    ...rest,
    enabled: enabled && hasNonEmptyProp(searchParams, ['postUuid', 'baseTokenAddress']),
    queryKey: [queryKey, 'Comments', searchParams],
    initialPageParam: { page, pageSize },
    queryFn: async ({ signal, pageParam }) => {
      const { data } = await api.community.getComments(
        {
          ...searchParams!,
          ...pageParam,
        },
        { signal }
      );
      return { ...data, ...pageParam };
    },
    placeholderData: keepPreviousData,
    getPreviousPageParam,
    getNextPageParam,
  });
};
